"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stargate_1 = require("@cosmjs/stargate");
/**
 * BlockchainClient is functionally the same with StargateClient,
 * with an additional static initializer:
 *
 * ```
 * BlockchainClient.connectWithTm(tmClient: Tendermint34Client)
 * ```
 *
 * @see StargateClient
 */
class BlockchainClient extends stargate_1.StargateClient {
    static connectWithTm(tmClient) {
        return new BlockchainClient(tmClient, {});
    }
}
exports.default = BlockchainClient;
